import { render, staticRenderFns } from "./settlementSystem.vue?vue&type=template&id=d1d5f2c4&scoped=true"
import script from "./settlementSystem.vue?vue&type=script&lang=js"
export * from "./settlementSystem.vue?vue&type=script&lang=js"
import style0 from "./settlementSystem.vue?vue&type=style&index=0&id=d1d5f2c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d5f2c4",
  null
  
)

export default component.exports